import { useEffect } from 'react';

const useOutsideClick = (refrence, callback) => {
	const handleClick = (e) => {
		if (refrence.current && !refrence.current.contains(e.target)) {
			callback();
		}
	};

	useEffect(() => {
		document.addEventListener('click', handleClick);

		return () => {
			document.removeEventListener('click', handleClick);
		};
	});
};

export default useOutsideClick;
